export default __webpack_public_path__ + "914293e449ff221f47d740c2abb58818.svg";